/* w9-bar-picker - the handlebar pages' picker (2026-10-17). Loaded by snippets/w9-bar-picker.liquid on the three bar
   products only; window.W9BarPicker comes from that snippet ({ line, files, viewer, data }).
   1. The Bend (or Rise) dropdown becomes buttons, each with a picture of that bend drawn from Warp 9's 3D model, seen
      from the front, in the color picked: Shopify Files w9bar-<product handle>-<bend>-<color>.png (handleized option
      values; made by crew-chief scripts/handlebar-pictures). A picture that isn't there leaves the button as words.
   2. The color dots become photos of the real bar in that color (each color's variant image), named underneath.
   3. The 3D bar in the description (<div data-w9hv data-line=...>): Crew Chief's viewer script is loaded when it comes
      near the screen. The viewer follows this picker.
   4. (2026-10-18, Sheldon) Picking a bend shows that bend's dimension picture in the gallery (the product image whose
      file name has -<bend>-bend, e.g. warp9-tapped-handlebar-ktm-sx-bend.png); picking a color goes back to that
      color's photo, as before. A link under the bend buttons, "Compare the bends in 3D below", scrolls to the 3D bar
      and turns on its comparison (data-compare on the spot before the viewer loads, a w9hv:compare event after).
   The selects stay the theme's source of truth: a button sets its select and fires change, as customColorSwatches.js
   does for the dots, so the theme's <variant-selects> (assets/scripts.js) and w9-picker.js work as before. */
(function () {
  'use strict';
  if (window.__w9bp) return; window.__w9bp = 1;
  var cfg = window.W9BarPicker || {};

  function handleize(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function shortColor(c) { return String(c).replace(/\b(anodized|anodised|powder\s*coat(ed)?)\b/ig, '').replace(/\s+/g, ' ').trim(); }
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  function sized(src, w) { return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  function fire(s) { s.dispatchEvent(new Event('change', { bubbles: true })); }

  function init(picker) {
    var optsEl = picker.querySelector('[data-id="product-options"]'), varsEl = picker.querySelector('[data-id="product-variants"]');
    if (!optsEl || !varsEl) return;
    var options, variants;
    try { options = JSON.parse(optsEl.textContent); variants = JSON.parse(varsEl.textContent); } catch (e) { return; }
    if (!Array.isArray(options) || !Array.isArray(variants) || !variants.length) return;
    var selects = Array.prototype.slice.call(picker.querySelectorAll('select'));
    if (selects.length !== options.length) return;
    var wraps = selects.map(function (s) { return s.closest('.product-form-input-dropdown'); });
    var ci = -1;
    options.forEach(function (name, i) { if (ci < 0 && /colou?r|finish/i.test(name)) ci = i; });
    if (ci < 0) return;
    var si = options.length === 2 ? 1 - ci : -1;          // the bend or rise: the bar's other option
    var handle = String(picker.getAttribute('data-url') || '').split('/').pop();
    var box = picker.closest('.product-variants') || picker;
    box.classList.add('w9bp');

    // 2. color dots: a photo of the real bar in each color
    var photos = {};
    variants.forEach(function (v) {
      var c = v.options[ci], img = v.featured_image;
      if (!photos[c] && img && img.src) photos[c] = img.src;
    });
    var dots = wraps[ci] ? wraps[ci].querySelector('.custom-color-swatches') : null;
    if (dots) {
      dots.classList.add('w9bp-photos');
      Array.prototype.forEach.call(dots.querySelectorAll('label'), function (l) {
        var input = l.querySelector('input'); if (!input || l.querySelector('.w9bp-img')) return;
        var src = photos[input.value];
        var pic = el('i', 'w9bp-img');
        if (src) pic.style.backgroundImage = 'url("' + sized(src, 240) + '")';
        else pic.style.cssText = l.getAttribute('style') || '';      // no photo: the store's swatch
        var name = el('span', 'w9bp-name'); name.textContent = shortColor(input.value);
        l.appendChild(pic); l.appendChild(name);
        l.classList.add('w9bp-photo');
      });
    }

    // 1. the bend or rise as picture buttons
    var shapeSel = si >= 0 ? selects[si] : null, buttons = [];
    function picture(shape, color) { return cfg.files ? sized(cfg.files + 'w9bar-' + handle + '-' + handleize(shape) + '-' + handleize(color) + '.png', 360) : ''; }
    if (shapeSel && wraps[si]) {
      var row = el('div', 'w9bp-shapes');
      row.setAttribute('role', 'radiogroup');
      row.setAttribute('aria-label', options[si]);
      Array.prototype.forEach.call(shapeSel.options, function (o) {
        var b = el('button', 'w9bp-shape'); b.type = 'button';
        b.setAttribute('role', 'radio');
        b.setAttribute('data-value', o.value);
        var img = el('img'); img.alt = ''; img.decoding = 'async';
        img.addEventListener('error', function () { b.classList.add('w9bp-noimg'); });
        img.addEventListener('load', function () { b.classList.remove('w9bp-noimg'); });
        var name = el('span'); name.textContent = o.value;
        b.appendChild(img); b.appendChild(name);
        b.addEventListener('click', function () {
          if (shapeSel.value !== o.value) { shapeSel.value = o.value; fire(shapeSel); }
          refresh();
          // after the theme has shown the variant's photo
          setTimeout(function () { showBend(o.value); }, 0);
        });
        row.appendChild(b); buttons.push(b);
      });
      shapeSel.classList.add('w9bp-hidden');
      shapeSel.setAttribute('tabindex', '-1');
      shapeSel.setAttribute('aria-hidden', 'true');
      shapeSel.parentNode.insertBefore(row, shapeSel.nextSibling);
    }

    // 4. the bend's dimension picture in the gallery, when the product has one
    function showBend(shape) {
      var gallery = document.getElementById('MediaGallery-' + picker.getAttribute('data-section'));
      if (!gallery || !gallery.setActiveMedia) return;
      var key = '-' + handleize(shape) + '-bend', id = null;
      Array.prototype.some.call(gallery.querySelectorAll('[data-media-id]'), function (m) {
        if (m.innerHTML.indexOf(key) >= 0) { id = m.getAttribute('data-media-id'); return true; }
        return false;
      });
      if (id) gallery.setActiveMedia(id, gallery.getAttribute('hide-variants') === 'true');
    }

    // 4. a link down to the 3D bar
    var spot = document.querySelector('[data-w9hv]');
    if (spot) {
      var compare = !!shapeSel && shapeSel.options.length > 1;
      var words = { 'mx-tapped': 'Compare the bends in 3D below', 'emoto-tapped': 'Compare the rises in 3D below' };
      var link = el('a', 'w9bp-3d-link');
      link.href = '#w9-3d';
      link.textContent = (compare && words[cfg.line]) || 'See this bar in 3D below';
      link.appendChild(el('span', 'w9bp-3d-arrow')).textContent = String.fromCharCode(8595); // down arrow
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (compare) {
          spot.setAttribute('data-compare', '1');            // read by the viewer when it loads
          spot.dispatchEvent(new CustomEvent('w9hv:compare')); // heard by a viewer already there
        }
        spot.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      var after = compare ? wraps[si] : wraps[ci];
      if (after) after.appendChild(link);
    }

    function refresh() {
      if (!shapeSel) return;
      var color = selects[ci].value;
      buttons.forEach(function (b) {
        var val = b.getAttribute('data-value'), on = val === shapeSel.value;
        b.setAttribute('aria-checked', String(on));
        b.tabIndex = on ? 0 : -1;
        var img = b.querySelector('img'), src = picture(val, color);
        if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
        if (!src) b.classList.add('w9bp-noimg');
      });
    }
    // after the theme's own handlers, and w9-picker's, have run
    picker.addEventListener('change', function () { setTimeout(refresh, 0); });
    if (window.MutationObserver && shapeSel) new MutationObserver(function () { setTimeout(refresh, 0); }).observe(shapeSel, { childList: true });
    refresh();

    // the other colors' pictures once the shopper reaches for the picker, so a color change swaps them at once
    var preloaded = false;
    function preload() {
      if (preloaded || !shapeSel || !cfg.files) return; preloaded = true;
      Array.prototype.forEach.call(shapeSel.options, function (o) {
        Array.prototype.forEach.call(selects[ci].options, function (c) { (new Image()).src = picture(o.value, c.value); });
      });
    }
    box.addEventListener('pointerover', preload);
    box.addEventListener('focusin', preload);
  }

  // 3. the 3D bar in the description
  function viewer() {
    var spots = Array.prototype.slice.call(document.querySelectorAll('[data-w9hv]'));
    if (!spots.length || !cfg.viewer) return;
    spots.forEach(function (s) {
      if (!s.getAttribute('data-line') && cfg.line) s.setAttribute('data-line', cfg.line);
      if (!s.getAttribute('data-data-url') && cfg.data) s.setAttribute('data-data-url', cfg.data);
    });
    var done = false;
    function load() {
      if (done) return; done = true;
      var s = document.createElement('script'); s.src = cfg.viewer; s.async = true;
      document.head.appendChild(s);
    }
    if (!('IntersectionObserver' in window)) return load();
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
    }, { rootMargin: '600px 0px' });
    spots.forEach(function (s) { io.observe(s); });
  }

  // after DOMContentLoaded: the description script (w9-product-details.js) has laid out the description by then
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('variant-selects'), init);
    viewer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
